import BreakPoint from '@naruto/naruto-theme/src/base/global/BreakPoint';
import { ThemeUnitItem } from './types';

export const CreateBreakUnits = (): ThemeUnitItem[] => [
  {
    key: 1,
    name: 'xs',
    size: 375
  },
  {
    key: 2,
    name: 'sm',
    size: 800
  },
  {
    key: 3,
    name: 'md',
    size: 1200
  },
  {
    key: 4,
    name: 'lg',
    size: 1400
  },
  {
    key: 5,
    name: 'xl',
    size: 1920
  }
];

export const CreateBreakPoint = (): any => ({
  xs: 374,
  sm: 799,
  md: 1199,
  lg: 1399,
  xl: 1919
});

export default {
  ...BreakPoint
};
